module.exports = "<div ng-if=\"$ctrl.isBottom\">Распознавание: <span ng-if=\"!$ctrl.isProcessing\" ng-click=\"$ctrl.recognize()\"><i class=\"icon-speech-recognition recognize-button\"></i></span> <span ng-if=\"$ctrl.isProcessing\"><i class=\"icon-loading animate-spin\"></i></span> <span ng-if=\"$ctrl.isError\" class=\"field-error\">{{:: \"Ошибка\" | gettext }}: {{$ctrl.result.message}}</span> <span ng-if=\"$ctrl.hasTranscript\">({{$ctrl.result.duration | timeSpan}}) {{$ctrl.result.transcript}}</span></div>"


//////////////////
// WEBPACK FOOTER
// ./src/facts/speech-recognition/speech-recognition-fact.component.html
// module id = 358
// module chunks = 0